import * as React from 'react';
import * as Session from '../../service/Session';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';
import * as ChatState from './ChatState';
import * as RB from 'react-bootstrap';

import moment from 'moment';
import { ChatTextMessage } from './ChatState';

type ChatUserListProps = {
    holdFocus: boolean;
    user: Session.UserState,
    syshdr: DTO.SystemHeader;
    chatusers: DTO.ChatUserState[];
    chatSelected: (locatorId: string, chat: DTO.ChatState) => void;
    selectedchat: DTO.ChatState;
    shareChatId?: number;
    new_messages: DTO.AgentTextMessage[];
    showShareChat: boolean;
    sortOrder: 'username' | 'legalname' | 'lastmsgtime';
};

export class ChatUserList extends React.Component<ChatUserListProps> {
    panelElem: HTMLDivElement | null = null;

    constructor(props: ChatUserListProps) {
        super(props);
    }

    chatSelected = (locatorId: string, chat: DTO.ChatState) => {
        return this.props.chatSelected(locatorId, chat);
    }

    //sortUserChats(a: DTO.ChatUserState, b: DTO.ChatUserState) {

    //    a.personalState.lastName > b.personalState.lastName ? 1 : (a.personalState.lastName < b.personalState.lastName ? -1 : 0
    //}

    doListSort(list: DTO.ChatUserState[], chatuser_order_new: number[]) {
        if (this.props.sortOrder == 'username') {
            return list.sort((a, b) => {
                return a.personalState.sortName > b.personalState.sortName ? 1 : (a.personalState.sortName < b.personalState.sortName ? -1 : 0)
            });
        }
        else if (this.props.sortOrder == 'legalname') {
            return list.sort((a, b) => {
                let aSort = (a.personalState.entity && a.personalState.entity.nickname ? a.personalState.entity.nickname : undefined);
                let bSort = (b.personalState.entity && b.personalState.entity.nickname ? b.personalState.entity.nickname : undefined);

                if (aSort && !bSort)
                    return 1;

                if (!aSort && bSort)
                    return -1;

                if (!aSort && !bSort)
                    return 0;

                if (aSort && bSort)
                    return aSort > bSort ? 1 : (aSort < bSort ? -1
                        : a.personalState.sortName > b.personalState.sortName ? 1 : (a.personalState.sortName < b.personalState.sortName ? -1 : 0))

                return 0;
            });
        }
        else if (this.props.sortOrder == 'lastmsgtime') {
            return list.sort((a, b) => {
                let aord = chatuser_order_new.findIndex(x => x == a.personalState.idperson);
                let bord = chatuser_order_new.findIndex(x => x == b.personalState.idperson);

                if (aord >= 0 || bord >= 0)
                    return aord < bord ? 1 : (aord > bord ? -1 : 0);

                return a.personalState.sortName > b.personalState.sortName ? 1 : (a.personalState.sortName < b.personalState.sortName ? -1 : 0)
            });
        }
        else {
            return list;
        }
    }

    render() {

        let users: JSX.Element[] = [];
        let chatShared: DTO.ChatState = { IdChat: this.props.shareChatId, title: 'Общий чат', privatechatuser: undefined };
        let shCat_new_cnt = this.props.new_messages.filter(x => x.idchat == this.props.shareChatId && (!this.props.user.personalState || x.idauthor != this.props.user.personalState.idperson)).length;

        if (this.props.showShareChat)
            users.push(<ChatUserListRow key={'idchat_' + this.props.shareChatId} selected={this.props.selectedchat.IdChat == this.props.shareChatId} chat={chatShared} holdFocus={this.props.holdFocus} chatSelected={this.chatSelected.bind(this)} new_messages_cnt={shCat_new_cnt} />);

        //let commonSel = this.props.selectedchat.IdChat == this.props.shareChatId;

        let chatuser_order_new: number[] = [];
        this.props.new_messages
            .sort((a, b) => a.messagetime < b.messagetime ? 1 : (a.messagetime > b.messagetime ? -1 : 0))
            .forEach((item) => { if (item.idchat != this.props.shareChatId && chatuser_order_new.findIndex(x => x == item.idauthor) < 0) chatuser_order_new.push(item.idauthor); });


        //this.props.chatusers
        //    .sort((a, b) => {
        //    let aord = chatuser_order_new.findIndex(x => x == a.personalState.idperson);
        //    let bord = chatuser_order_new.findIndex(x => x == b.personalState.idperson);

        //    if (aord >= 0 || bord >= 0)
        //        return aord < bord ? 1 : (aord > bord ? -1 : 0);

        //    return a.personalState.sortName > b.personalState.sortName ? 1 : (a.personalState.sortName < b.personalState.sortName ? -1 : 0)
        //}
        //)

        this.doListSort(this.props.chatusers, chatuser_order_new)
            .forEach((val, key) => {
            let selected = false;
            if (this.props.selectedchat.privatechatuser) {
                selected = this.props.selectedchat.privatechatuser.personalState.idperson == val.personalState.idperson;
            }

                let chat: DTO.ChatState = { IdChat: undefined, title: undefined, privatechatuser: val };
                let chat_new_cnt = this.props.new_messages.filter(x => x.idauthor == val.personalState.idperson && x.idchat != this.props.shareChatId).length;

                let rkey = chat.IdChat ? 'idchat_' + chat.IdChat : (chat.privatechatuser ? 'idcp_' + chat.privatechatuser.personalState.idperson : '_');

                users.push(<ChatUserListRow key={rkey} selected={selected} chat={chat} holdFocus={this.props.holdFocus} chatSelected={this.chatSelected.bind(this)} new_messages_cnt={chat_new_cnt} />);
        });


        return <div className='panel panel-default'>
            <div className={'panel-body otc-panel-impactor-users'} ref={(panel) => { this.panelElem = panel }}>
                <ul>
                    {users}
                </ul>
            </div>
        </div>;
    }
}



interface ChatUserListRowProps {
    new_messages_cnt: number;
    selected: boolean;
    holdFocus: boolean;
    chat: DTO.ChatState;
    chatSelected: (locatorId: string, chatuser: DTO.ChatState) => void;
}

class ChatUserListRow extends React.Component<ChatUserListRowProps> {

    _onSelectRecord = (locatorId: string, chatuser: DTO.ChatState) => {
        return this.props.chatSelected(locatorId, chatuser);
    }


    render() {
        //var liClass: string = (this.props.record.hasownedrecs ? 'owned-recs' : '') + ' ' + (this.state.selected && this.props.holdFocus ? 'rowselected' : (this.state.selected && !this.props.holdFocus ? 'rowonblur' : ''));
        //let newRecs = this.props.chat.privatechatuser.connectStatus == 'Online' ? 'owned-recs'
        let newRecs = this.props.new_messages_cnt > 0;
        var liClass: string = (newRecs ? 'owned-recs' : '') + ' ' + (this.props.selected && this.props.holdFocus ? 'rowselected' : (this.props.selected && !this.props.holdFocus ? 'rowonblur' : ''));

        //var wellClass = (this.props.selected ? 'well-selected' : undefined);
        //let username = this.props.chatuser.personalState.lastName + ' ' + this.props.chatuser.personalState.firstName + ' ' + this.props.chatuser.personalState.sureName;

        //let wellFrame = <RB.Well bsSize="sm" className={wellClass} style={{ position: 'relative' }}>
        //    <div>{username}</div>
        //</RB.Well>
        let icoCls = this.props.chat.privatechatuser ? 'glyphicon glyphicon-user' : 'glyphicon glyphicon-home'
        let icon = <span className={icoCls} aria-hidden="true"></span >        

        let authorName = '';
        let authorEntName = undefined;
        
        if (this.props.chat.title) {
            //authorCap = <div className={'author-title'}><strong>{this.props.chat.title}</strong></div>
            authorName = this.props.chat.title;
        }
        else if (this.props.chat.privatechatuser) {
            if (this.props.chat.privatechatuser.personalState.lastName && this.props.chat.privatechatuser.personalState.firstName) {
                authorName = this.props.chat.privatechatuser.personalState.lastName + ' ' + this.props.chat.privatechatuser.personalState.firstName;
            }
            else {
                authorName = '(' + this.props.chat.privatechatuser.personalState.email + ')';
            }
            authorEntName = (this.props.chat.privatechatuser.personalState.entity ? this.props.chat.privatechatuser.personalState.entity.nickname : '');
            authorEntName = <span className={'author-entity'}>{authorEntName}</span>
            //authorCap = <div> {authorName}{' '}<span className={'author-entity'}>{authorEntName}</span></div>

            //className = { 'message-text'}>
        }
        else {
            authorName = 'Unnamed #' + this.props.chat.IdChat;
        }

        //style={{ float: 'left:!important' }}
        let caption = <div className='user-caption circle-icon' style={{ float: 'left' }}>{icon}{' '}{authorName}{authorEntName}</div>

        //let clsText = this.props.user.personalState ? (message.author.idperson == this.props.user.personalState.idperson ? 'person-message-text' : 'message-text') : 'message-text';
        //<div className={clsText}>{message.messagetext}</div>


        //let bg_color = this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white');
        let bg_color = undefined;

        //let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};
        let crsr = { cursor: 'pointer' } ;

        //let animation_mod = this.state.modified ? { animation: 'newdata_blink_green 1s 10' } : {}
        let animation_mod = {}

        var liStyle = {
            ...{ backgroundColor: bg_color }, ...crsr, ...animation_mod, ...{ position: 'relative' as "relative"}
        };

        let locator = this.props.chat.IdChat ? 'idchat_' + this.props.chat.IdChat : (this.props.chat.privatechatuser ? 'idcp_' + this.props.chat.privatechatuser.personalState.idperson : '_');
        //console.log('locator');
        //console.log(locator);

        return <li className={liClass} style={liStyle}
            onClick={this._onSelectRecord.bind(this, locator, this.props.chat)}>            
            {caption}
            {/*
            <div className={'time-field'}><span>{this.props.chat.connectStatus}</span></div>
            */}
        </li>
    }
}